<template>
  <div>
    <table class="table-hover table">
      <thead>
      <tr>
        <th>Template</th>
        <th>Layout</th>
        <th>Topic</th>
        <th>Latest Update</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="tpl in templates" :key="tpl.id">
        <td>{{ tpl.name }}</td>
        <td>{{ tpl.layout }}</td>
        <td>{{ tpl.topic }}</td>
        <td>{{ tpl.lastUpdate | aTime('from') }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      templates: 'getTemplates'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Templates/List.vue